"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _toPairs = _interopRequireDefault(require("lodash/fp/toPairs"));
var _fromPairs = _interopRequireDefault(require("lodash/fp/fromPairs"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _mapValues = _interopRequireDefault(require("lodash/fp/mapValues"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _isObjectLike = _interopRequireDefault(require("lodash/fp/isObjectLike"));
var _useForm = _interopRequireDefault(require("./useForm"));
var _FormContext = require("./FormContext");
var _FormStateWatcher = _interopRequireDefault(require("./FormStateWatcher"));
var _utils = require("./utils");
var _excluded = ["horizontal", "groupGap", "trimInput", "initialTouched", "initialErrors", "initialValues", "enableReinitialize", "validate", "validateOnChange", "validateOnBlur", "validateOnMount", "onReset", "onSubmit", "onChange", "children", "className", "disableBrowserValidation", "customizeLayout"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function formObjMapper(mapper) {
  return function (value, key) {
    return (0, _isObjectLike["default"])(value) ? (0, _mapValues["default"])(formObjMapper(mapper))(value) : mapper(value, key);
  };
}
function trimFieldValuesOnNeeds(values, fieldConfigs) {
  return (0, _compose["default"])(_fromPairs["default"], (0, _map["default"])(function (_ref) {
    var _fieldConfigs$key;
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, (_fieldConfigs$key = fieldConfigs[key]) !== null && _fieldConfigs$key !== void 0 && _fieldConfigs$key.doNotTrimValue ? value : (0, _utils.trimAny)(value)];
  }), _toPairs["default"])(values);
}
var Form = function Form(_ref3) {
  var horizontal = _ref3.horizontal,
    groupGap = _ref3.groupGap,
    trimInput = _ref3.trimInput,
    initialTouched = _ref3.initialTouched,
    initialErrors = _ref3.initialErrors,
    _ref3$initialValues = _ref3.initialValues,
    initialValues = _ref3$initialValues === void 0 ? {} : _ref3$initialValues,
    enableReinitialize = _ref3.enableReinitialize,
    validate = _ref3.validate,
    validateOnChange = _ref3.validateOnChange,
    validateOnBlur = _ref3.validateOnBlur,
    validateOnMount = _ref3.validateOnMount,
    onReset = _ref3.onReset,
    onSubmit = _ref3.onSubmit,
    onChange = _ref3.onChange,
    children = _ref3.children,
    className = _ref3.className,
    _ref3$disableBrowserV = _ref3.disableBrowserValidation,
    disableBrowserValidation = _ref3$disableBrowserV === void 0 ? false : _ref3$disableBrowserV,
    _ref3$customizeLayout = _ref3.customizeLayout,
    customizeLayout = _ref3$customizeLayout === void 0 ? false : _ref3$customizeLayout,
    formAttr = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var fieldsConfig = _react["default"].useRef({});
  var wrappedOnSubmit = (0, _react.useCallback)(function (values) {
    if (!onSubmit) {
      return undefined;
    }
    return trimInput ? onSubmit(trimFieldValuesOnNeeds(values, fieldsConfig.current)) : onSubmit(values);
  }, [onSubmit, trimInput]);
  var wrappedOnChange = (0, _react.useCallback)(function (formState) {
    if (!onChange) {
      return undefined;
    }
    return trimInput ? onChange(_objectSpread(_objectSpread({}, formState), {}, {
      values: trimFieldValuesOnNeeds(formState.values, fieldsConfig.current)
    })) : onChange(formState);
  }, [onChange, trimInput]);
  var formValidate = (0, _react.useMemo)(function () {
    return validate && function (v) {
      return trimInput ? validate(trimFieldValuesOnNeeds(v, fieldsConfig.current)) : validate(v);
    };
  }, [validate, trimInput]);
  var formik = (0, _useForm["default"])({
    initialTouched: initialTouched,
    initialErrors: initialErrors,
    initialValues: initialValues,
    enableReinitialize: enableReinitialize,
    validate: formValidate,
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onReset: onReset,
    onSubmit: wrappedOnSubmit
  });
  var registerField = (0, _react.useCallback)(function (name, field) {
    Object.assign(fieldsConfig.current, (0, _defineProperty2["default"])({}, name, field.config));
    formik.registerField(name, field);
  }, [formik]);
  var validateForm = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(options) {
      var errors;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return formik.validateForm(options === null || options === void 0 ? void 0 : options.values);
          case 2:
            errors = _context.sent;
            if (options !== null && options !== void 0 && options.shouldTouchFields && !(0, _isEmpty["default"])(errors)) {
              formik.setTouched((0, _mapValues["default"])(formObjMapper(function () {
                return true;
              }))(errors));
            }
            return _context.abrupt("return", errors);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [formik]);
  var handleSubmit = (0, _react.useCallback)(function (e) {
    validateForm({
      shouldTouchFields: true
    });
    formik.handleSubmit(e);
  }, [validateForm, formik]);
  return /*#__PURE__*/_react["default"].createElement(_FormContext.FormProvider, {
    value: {
      customizeLayout: customizeLayout,
      form: _objectSpread(_objectSpread({
        alignment: horizontal ? _FormContext.HORIZONTAL : _FormContext.VERTICAL
      }, formik), {}, {
        registerField: registerField,
        trimInput: trimInput,
        validateForm: validateForm
      })
    }
  }, /*#__PURE__*/_react["default"].createElement(_FormStateWatcher["default"], (0, _extends2["default"])({}, formik, {
    onChange: wrappedOnChange
  })), typeof children === 'function' ? children(formik) : /*#__PURE__*/_react["default"].createElement("form", (0, _extends2["default"])({
    className: (0, _classnames2["default"])('form', (0, _defineProperty2["default"])({
      'form-horizontal-md': horizontal
    }, "form-gap-".concat(groupGap), !!groupGap && groupGap !== 'md'), className),
    noValidate: disableBrowserValidation,
    onSubmit: handleSubmit,
    "aria-atomic": "true"
  }, (0, _omit["default"])(['onTouched'], formAttr)), children));
};
var _default = exports["default"] = Form;